<div>
  <div class="flex row-collapse space-between">
    <p>
      <span>{{ 'revenue.post-transactions.total-debit' | translate }} </span>
      {{ totalDebit | currency }}
      <span>{{ 'revenue.post-transactions.total-credit' | translate }} </span>
      {{ totalCredit | currency }}
    </p>
    <div class="flex row-collapse space-between">
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary mt-5 mr-27 mb-27"
        [disabled]="exportingSummaries"
        (click)="exportSummaries()"
      >
        <wl-busy [show]="exportingSummaries"></wl-busy>
        {{ 'revenue.journal-entry-details.export-summaries' | translate | titlecase }}
      </button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary mt-5 mr-12 mb-27"
        [disabled]="exportingDetails"
        (click)="exportDetails()"
      >
        <wl-busy [show]="exportingDetails"></wl-busy>
        {{ 'revenue.journal-entry-details.export-details' | translate | titlecase }}
      </button>
    </div>
  </div>
  <p-table
    [showGridlines]="true"
    [value]="searchResult?.Result"
    [paginator]="true"
    [rows]="searchParams ? searchParams.PageSize : 20"
    [lazy]="true"
    [totalRecords]="searchResult?.TotalCount"
    (onLazyLoad)="lazyLoad($event)"
  >
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="fs-12px">
        <th pSortableColumn="ApplyDate" style="min-width: 123px">
          {{ 'revenue.journal-entry-details.apply-date' | translate | titlecase }}
          <p-sortIcon field="ApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="Account" style="min-width: 101px">
          {{ 'revenue.post-transactions.account' | translate | titlecase }}
          <p-sortIcon field="Account"></p-sortIcon>
        </th>
        <th pSortableColumn="JournalEntryDescription" style="min-width: 124px">
          {{ 'common.description' | translate | titlecase }}
          <p-sortIcon field="JournalEntryDescription"></p-sortIcon>
        </th>
        <th *ngIf="!hideClassColumn" style="min-width: 120px">
          {{ 'revenue.post-transactions.class-sub-class' | translate | titlecase }}
        </th>
        <th *ngIf="!hideIntacctColumns" pSortableColumn="Department" style="min-width: 128px">
          {{ 'revenue.post-transactions.department' | translate | titlecase }}
          <p-sortIcon field="Department"></p-sortIcon>
        </th>
        <th *ngIf="!hideIntacctColumns" pSortableColumn="Location" style="min-width: 105px">
          {{ 'revenue.post-transactions.location' | translate | titlecase }}
          <p-sortIcon field="Location"></p-sortIcon>
        </th>
        <th pSortableColumn="DebitAmount" style="min-width: 140px">
          {{ 'revenue.post-transactions.debit-amount' | translate | titlecase }}
          <p-sortIcon field="DebitAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="CreditAmount" style="min-width: 144px">
          {{ 'revenue.post-transactions.credit-amount' | translate | titlecase }}
          <p-sortIcon field="CreditAmount"></p-sortIcon>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-transaction>
      <tr class="fs-12px">
        <td>
          {{ transaction.ApplyDate | date: 'M/d/yyyy' }}
        </td>
        <td>
          {{ transaction.Account }}
        </td>
        <td>
          {{ transaction.JournalEntryDescription }}
        </td>
        <td *ngIf="!hideClassColumn">
          {{ transaction.ClassName }}
        </td>
        <td *ngIf="!hideIntacctColumns">
          {{ transaction.Department }}
        </td>
        <td *ngIf="!hideIntacctColumns">
          {{ transaction.Location }}
        </td>
        <td>
          <div class="mct-flex mr-27 mct-justify-end mct-items-stretch">
            {{ transaction.DebitAmount | currency }}
          </div>
        </td>
        <td>
          <div class="mct-flex mr-27 mct-justify-end mct-items-stretch">
            {{ transaction.CreditAmount | currency }}
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft">
      <a [hidden]="hideShowAll" (click)="showAll()">{{ 'common.page-size.show-all' | translate | titlecase }}</a>
    </ng-template>
    <ng-template pTemplate="paginatorright"> </ng-template>
  </p-table>
</div>
